import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory'
import './index.scss';
import 'bootstrap/dist/css/bootstrap.css';
// import Routes from './routes';
import App from './App';
const history = createHistory();

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js